/**
 *
 * Accordion
 *
 */
( function( $ ) {
	'use strict';

	$( '.js-accordion__toggle' ).click( function(){
		$( this ).toggleClass( 'js-accordion--active' );
		$( this ).next().slideToggle( 200 );
	} );

} ) ( jQuery );
